export class PlaybackError extends Error {
    constructor(code, message) {
        super();
        /**
         * Will be set to `true` if the severity of the error is such that the
         * player can't recover from it - for example when it's sprung from the
         * platform not supporting the required technologies.
         */
        this.unrecoverable = false;
        /**
         * Will be set to true if the error should be ignored in the listplayer's
         * error counter.
         *
         * From inline description of this in player:
         * The list player takes note of the number of errors that occur and
         * stops playback after a certain threshold. If the track is not
         * protected (which is assume for ads), we want the list player to
         * ignore the error.
         */
        this.listPlayerIgnore = false;
        /**
         * Object for storing properties of an event that's useful for debugging.
         */
        this.debug = {};
        this.name = 'PlaybackError';
        this.code = code;
        this.message = message;
    }
    static fatal(code, message) {
        const error = new PlaybackError(code, message);
        error.unrecoverable = true;
        return error;
    }
}
//# sourceMappingURL=playback.js.map